import { render, staticRenderFns } from "./KYC.vue?vue&type=template&id=3d0388b3&scoped=true"
import script from "./KYC.vue?vue&type=script&lang=js"
export * from "./KYC.vue?vue&type=script&lang=js"
import style0 from "./KYC.vue?vue&type=style&index=0&id=3d0388b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0388b3",
  null
  
)

export default component.exports